import { render } from "./ProductsView.vue?vue&type=template&id=2b1db80a&scoped=true"
import script from "./ProductsView.vue?vue&type=script&lang=js"
export * from "./ProductsView.vue?vue&type=script&lang=js"

import "./ProductsView.vue?vue&type=style&index=0&id=2b1db80a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1db80a"]])

export default __exports__